import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity, Text, ActivityIndicator } from 'react-native';
import InputDefault from "../../components/Form/InputDefault";
import { LinearGradient } from "expo-linear-gradient";
import RNPickerSelect from "react-native-picker-select";
import AsyncStorage from '@react-native-async-storage/async-storage';

import HeaderDefault from '../../components/HeaderDefault';
import { toast } from '../../utils/toast';
import api from '../../services/api';

import styles from './styles';

const EditBankAccount = ({ route, navigation }) => {
    const [bank, setBank] = useState(0);
    const [typeAccount, setTypeAccount] = useState(0);
    const [agency, setAgency] = useState('');
    const [account, setAccount] = useState('');
    const [itemsBanks, setItemsBanks] = useState([]);
    const [accountType, setAccountType] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { item } = route.params;

    useEffect(() => {
        getBanks();
        getAccountType();
        setBank(item.bankId);
        setTypeAccount(item.typeAccountId);
        setAgency(item.agency);
        setAccount(item.account);
    }, []);

    function getBanks() {
        setIsLoading(true);
        api.get('/banks')
            .then((res) => {
                var banks = [];

                res.data.data.map(item => {
                    banks.push({
                        'label': item.bank,
                        'value': item.id
                    })
                })

                setItemsBanks(banks);
                setIsLoading(false);
            })
            .catch(() => {
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }

    function getAccountType() {
        setIsLoading(true);
        api.get('/bank-account-types')
            .then((res) => {
                var types = [];

                res.data.data.map(item => {
                    types.push({
                        'label': item.name,
                        'value': item.id
                    })
                })

                setAccountType(types);
                setIsLoading(false);
            })
            .catch(() => {
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }

    async function updateBank() {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        if (!bank) {
            toast("Selecione um banco.", "#DA1414");
            return false;
        }

        if (!typeAccount) {
            toast("Selecione um tipo de conta.", "#DA1414");
            return false;
        }

        if (!agency) {
            toast("Preencha o número da agência.", "#DA1414");
            return false;
        }

        if (!account) {
            toast("Preencha o número da conta.", "#DA1414");
            return false;
        }

        setIsLoading(true);
        const data = {
            "bank_id": bank,
            "bank_account_type_id": typeAccount,
            "branch": agency,
            "account": account
        };

        api.put(`/bank-accounts/${item.id}`, data, { headers: { 'Content-Type': 'application/json', 'Authorization': `Basic ${token}` } })
            .then(() => {
                navigation.navigate('BankAccount');
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error)
                toast("Houve um erro ao cadastrar, tente novamente mais tarde.", "#DA1414");
                setIsLoading(false);
            })
    }

    return (
        <>
            <HeaderDefault title={'Editar conta'} />

            <View style={styles.container}>
                <RNPickerSelect
                    onValueChange={(value) => setBank(value)}
                    placeholder={{
                        label: 'Selecione o banco',
                        value: 0,
                    }}
                    items={itemsBanks}
                    value={bank}
                    style={{
                        inputWeb: {
                            borderRadius: 4,
                            paddingHorizontal: 10,
                            height: 40,
                            marginVertical: 10,
                            color: '#222'
                        }
                    }}
                />

                <RNPickerSelect
                    onValueChange={(value) => setTypeAccount(value)}
                    placeholder={{
                        label: 'Selecione o tipo de conta',
                        value: 0,
                    }}
                    items={accountType}
                    value={typeAccount}
                    style={{
                        inputWeb: {
                            borderRadius: 4,
                            paddingHorizontal: 10,
                            height: 40,
                            marginVertical: 10,
                            color: '#222'
                        }
                    }} />

                <InputDefault
                    value={agency}
                    onValueChange={(value) => setAgency(value)}
                    placeholder={"Agência"}
                />

                <InputDefault
                    value={account}
                    onValueChange={(value) => setAccount(value)}
                    placeholder={"Conta"}
                />
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={updateBank} disabled={isLoading ? true : false}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        {isLoading ? (
                            <ActivityIndicator color="#1FBFB5" size="small" />
                        ) : (
                            <Text style={styles.textBtn}>SALVAR</Text>
                        )}
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default EditBankAccount;